module.exports = __webpack_public_path__ + "img/l1.fe05c3ce.png";